import { call, put } from 'redux-saga/effects';
import { OffersAsyncActions } from 'store/actions/offers';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* createCounter(action) {
  const {
    CreateCounterOffer: {
      Actions: { SUCCESS, FAILURE },
    },
  } = OffersAsyncActions;
  const {
    payload: { counterOffer },
  } = action;

  try {
    const response = yield call(apiCall, '/offers/counter', 'post', counterOffer);
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default createCounter;
